import React , {Component} from "react"
import {Header} from "../HeaderComponent/HeaderComponent";
import {Accueil} from "../AcceuilComponent/AcceuilComponent";
import {Client} from "../ClientComponent/ClientComponent";
import {Partenaire} from "../PartenaireComponent/PartenaireComponent";
import {Contact} from "../ContactUsComponent/ContactUsComponent";
import {Footer} from "../FooterComponent/FooterComponent";
import { FAQ} from "../FAQComponent/FAQComponent";
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';



const mapStateToProps = state => {
    return {
        dummy: state.dummy,
    }
}
const mapDispatchToProps = (dispatch) => ({});


class Main extends Component{
    constructor(props) {
        super(props);
    }
    componentDidMount() {
            console.log("DUMMY =" , this.props.dummy);
    }

    render() {
        return(
            <React.Fragment>
                <Header/>
                <Switch>
                    <Route exact path="/acceuil" component={()=><Accueil/>} />
                    <Route exact path="/client" component={()=><Client/>}/>
                    <Route exact path="/partenaire" component={()=><Partenaire/>}/>
                    <Route exact path="/FAQ" component={()=><FAQ/>} />
                    <Route exact path="/contact" component={()=><Contact/>}/>
                    <Redirect to={"/acceuil"}/>
                    {/*<Route path="/Categories/:categoryName/:type/:quizIndice" component={Quiz} />*/}
                    {/*<Route exact path="/" component={()=><Categories borders={this.props.Esthetics ? this.props.Esthetics.filter(esthetic=>esthetic.id==='Borders')[0].CategoriesBorders : null} auth={this.props.auth} categories={this.props.Categories}/>} />*/}
                    {/*<Route exact path='/contactUs' component={()=><Contact sendMessage={this.props.sendMessage} closeModal={this.props.closeModalSendMessage} sendMessageStatus={this.props.sendMessageStatus} />} />*/}
                    {/*<Route path="/ads-policy" component={()=><Ads/>} />*/}
                    {/*<Route path="/privacy-policy" component={()=><Privacy/>} />*/}
                </Switch>
                <Footer/>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));